import ChartLegend from './chartlegend.js';

nn.component.ChartLegend = ChartLegend;
